/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single message preview from a Gmail search result
 * @export
 * @interface GmailMessagePreview
 */
export interface GmailMessagePreview {
    /**
     * Gmail message ID
     * @type {string}
     * @memberof GmailMessagePreview
     */
    messageId: string;
    /**
     * Gmail thread ID this message belongs to
     * @type {string}
     * @memberof GmailMessagePreview
     */
    threadId: string;
    /**
     * Email subject
     * @type {string}
     * @memberof GmailMessagePreview
     */
    subject: string;
    /**
     * Sender (formatted: Name <email> or just email)
     * @type {string}
     * @memberof GmailMessagePreview
     */
    from: string;
    /**
     * Recipients (formatted)
     * @type {string}
     * @memberof GmailMessagePreview
     */
    to: string;
    /**
     * Short snippet / preview text
     * @type {string}
     * @memberof GmailMessagePreview
     */
    snippet: string;
    /**
     * When the message was sent
     * @type {string}
     * @memberof GmailMessagePreview
     */
    date: string;
    /**
     * Whether this message is already imported into this claim
     * @type {boolean}
     * @memberof GmailMessagePreview
     */
    alreadyImported: boolean;
}

/**
 * Check if a given object implements the GmailMessagePreview interface.
 */
export function instanceOfGmailMessagePreview(value: object): value is GmailMessagePreview {
    if (!('messageId' in value) || value['messageId'] === undefined) return false;
    if (!('threadId' in value) || value['threadId'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    if (!('snippet' in value) || value['snippet'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('alreadyImported' in value) || value['alreadyImported'] === undefined) return false;
    return true;
}

export function GmailMessagePreviewFromJSON(json: any): GmailMessagePreview {
    return GmailMessagePreviewFromJSONTyped(json, false);
}

export function GmailMessagePreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): GmailMessagePreview {
    if (json == null) {
        return json;
    }
    return {
        
        'messageId': json['messageId'],
        'threadId': json['threadId'],
        'subject': json['subject'],
        'from': json['from'],
        'to': json['to'],
        'snippet': json['snippet'],
        'date': json['date'],
        'alreadyImported': json['alreadyImported'],
    };
}

export function GmailMessagePreviewToJSON(json: any): GmailMessagePreview {
    return GmailMessagePreviewToJSONTyped(json, false);
}

export function GmailMessagePreviewToJSONTyped(value?: GmailMessagePreview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messageId': value['messageId'],
        'threadId': value['threadId'],
        'subject': value['subject'],
        'from': value['from'],
        'to': value['to'],
        'snippet': value['snippet'],
        'date': value['date'],
        'alreadyImported': value['alreadyImported'],
    };
}

